import React from 'react';
class Platform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      limit: '450px',
      height: 'auto',
    };
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }
  render() {
    return (
      <div
        ref={divElement => {
          this.divElement = divElement;
        }}
        className="relative"
        id={this.props.id}
      >
        <div style={{ height: this.state.height }} className="overflow-hidden">
          {this.state.show ? this.props.children : this.props.children?.[0]}
        </div>
        <div className="absolute flex w-full bottom-0 left-0 right-0 justify-center z-10">
          <div
            onClick={this.toggleVisibility}
            className={
              'flex justify-center items-center bg-green -mb-15 rounded-5 mx-auto text-center cursor-pointer custom-shadow ' +
              (this.state.show ? 'transform rotate-180' : '')
            }
          >
            <div className="scroll-down-animation" />
          </div>
        </div>
        <div
          className="absolute w-full bottom-0 h-15 -mb-15"
          style={{
            boxShadow: '0px -3px 4px rgba(0, 0, 0, 0.1)',
            display: !this.state.show ? 'flex' : 'none',
          }}
        />
        <style jsx global>
          {`
            .custom-shadow {
              -webkit-box-shadow: 5px 5px 22px 5px #00000052;
              box-shadow: 5px 5px 22px 5px #00000052;
            }
            .scroll-down-animation {
              position: relative;
              display: block;
              opacity: 0;
              transition: all 0.4s ease;
              line-height: 0;
              font-size: 0;
              color: transparent;
              margin-left: auto;
              margin-right: auto;
              width: 50px;
              height: 48px;
              background-size: 0 auto;
              animation: pulse 1.5s 0s infinite normal ease forwards;
              background-image: url('/images/icons/arrow-bottom-white-animation.svg');
              background-repeat: no-repeat;
              margin-top: -10px;
              margin-bottom: -10px;
            }
            .scroll-down-animation:before,
            .scroll-down-animation:after {
              content: ' ';
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              width: 100%;
              height: 100%;
              background: url('/images/icons/arrow-bottom-white-animation.svg') no-repeat center top;
              background-size: 100% auto;
            }
            .scroll-down-animation:before {
              animation: pulse 1.5s 0.25s infinite normal ease forwards;
            }
            .scroll-down-animation:after {
              animation: pulse 1.5s 0.5s infinite normal ease forwards;
            }

            @keyframes pulse {
              0% {
                opacity: 0;
                background-position: center top;
                background-size: 0 auto;
              }
              10% {
                opacity: 0;
              }
              50% {
                opacity: 1;
                background-size: 75% auto;
              }
              90% {
                opacity: 0;
              }
              100% {
                opacity: 0;
                background-position: center bottom;
                background-size: 0 auto;
              }
            }
          `}
        </style>
      </div>
    );
  }
  toggleVisibility() {
    const self = this;
    if (this.state.show) {
      self.props.scrollToPlatform(self.props.id, 40, false);
    } else {
      self.props.hideAll();
      setTimeout(function () {
        self.show();
      }, 500);
    }
  }
  show() {
    this.setState({ show: true, height: 'auto', limit: 'auto' });
  }
  hide() {
    this.setState({ show: false, height: '450px' });
  }
  componentDidMount() {
    if (!this.props.show) {
      this.setState({ show: false, height: this.state.limit });
    }
  }
}
export default Platform;
